import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrl: './banner.component.scss',
    standalone: false
})
export class BannerComponent {
  lang: string = '';
  private readonly translate = inject(TranslateService);

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    items: 1,
    nav: false
  };

  slides = [
    { id: '1', src: 'assets/images/png/hero-people.png', alt: 'PUPA community members and volunteers 1' },
    { id: '2', src: 'assets/images/png/hero-people.png', alt: 'PUPA community members and volunteers 2' },
    { id: '3', src: 'assets/images/png/hero-people.png', alt: 'PUPA community members and volunteers 3' },
    { id: '4', src: 'assets/images/png/hero-people.png', alt: 'PUPA community members and volunteers 4' },
    { id: '5', src: 'assets/images/png/hero-people.png', alt: 'PUPA community members and volunteers 5' }
  ];

  constructor() {
    this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe((params: LangChangeEvent) => {
      this.lang = params.lang;
    });
  }
}

